import {
  GET_AUTH_INFO,
  GET_AUTH_INFO_ERROR,
  GET_AUTH_INFO_SUCCESS,
  GET_TOKEN,
  GET_TOKEN_ERROR,
  GET_TOKEN_SUCCESS
} from './AuthorizationProvider.actions'

const authorizationProviderState = {
  accessToken: undefined,
  authInfo: {
    dni: null,
    loading: false,
    error: undefined,
    hasObserverRole: false,
    isBuyer: false,
    isSeller: false,
    orgCode: '',
    userCode: '',
    userName: '',
    userType: '',
    orgTaxID: ''
  },
  gettingToken: true,
  error: false
}

/**
 * The authorization provider's reducer.
 */
const authorizationProviderReducer = (state = authorizationProviderState, { payload, type }) => {
  switch (type) {
    case GET_AUTH_INFO: {
      return { ...state, authInfo: { ...state.authInfo, loading: true } }
    }
    case GET_AUTH_INFO_ERROR: {
      return { ...state, authInfo: { ...state.authInfo, error: payload.error, loading: false } }
    }
    case GET_AUTH_INFO_SUCCESS: {
      return { ...state, authInfo: { ...state.authInfo, ...payload.authInfo, loading: false } }
    }
    case GET_TOKEN: {
      return { ...state, gettingToken: true, error: false, accessToken: undefined }
    }
    case GET_TOKEN_ERROR: {
      return { ...state, gettingToken: false, error: true }
    }
    case GET_TOKEN_SUCCESS: {
      return { ...state, gettingToken: false, accessToken: payload.accessToken, error: false }
    }
    default: {
      return state
    }
  }
}

export default authorizationProviderReducer
